import {featureService} from "@/src/modules/core/services/feature";

type PermissionCheck = (permission: string) => boolean;

/** Same gate as nav dynamic routes: property section granted + `{resource} show`. */
export function canQuickActionDar(getHasPermission: PermissionCheck) {
  return featureService.getIsFeatureEnabled("dars") && getHasPermission("dar show");
}

export function canQuickActionIncident(getHasPermission: PermissionCheck) {
  return (
    featureService.getIsFeatureEnabled("incidents") && getHasPermission("incidentreport show")
  );
}

export function canQuickActionDispatchLog(getHasPermission: PermissionCheck) {
  return (
    featureService.getIsFeatureEnabled("dispatchlogs") && getHasPermission("dispatchlog store")
  );
}

export function canQuickActionParking(getHasPermission: PermissionCheck) {
  return featureService.isVehiclesEnabled && getHasPermission("vehicle show");
}

export function canQuickActionAmenitySection(
  sectionKey: string,
  getHasPermission: PermissionCheck,
) {
  return (
    featureService.getIsFeatureEnabled(sectionKey) && getHasPermission("amenityaccesslog show")
  );
}
